export default __webpack_public_path__ + "img/dvZSztzl.71c13cf0.svg";